export const locale = {
    lang: 'es',
    data: {
        'AUTHENTICATION': {
            'WELCOME': ' Panel de control SmartBiometrik',
            'THANKS': ' ¡Gracias por usar SmartBiometrik!',
            'SEE_YOU_SOON': '¡Hasta pronto!',
        }
    }
};
